import { render, staticRenderFns } from "./Onboard.vue?vue&type=template&id=b6d274d0&scoped=true"
import script from "./Onboard.vue?vue&type=script&lang=ts"
export * from "./Onboard.vue?vue&type=script&lang=ts"
import style0 from "./Onboard.vue?vue&type=style&index=0&id=b6d274d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d274d0",
  null
  
)

export default component.exports